<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    destroy-on-close
    @close="handleClose"
  >
    <el-form label-width="120px" :model="editForm" ref="editForm">
      <el-form-item label="角色标识">
        <el-input
          size="small"
          v-model="editForm.perms"
          auto-complete="off"
          placeholder="角色标识"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色名称">
        <el-input
          size="small"
          v-model="editForm.roleName"
          auto-complete="off"
          placeholder="角色名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          size="small"
          type="textarea"
          v-model="editForm.remark"
          auto-complete="off"
          placeholder="备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" type="primary" @click="handleSubmit"
        >确定</el-button
      >
      <el-button size="small" @click="handleClose">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveOrUpdateRole } from "@/api/system/role";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({
        deptId: "",
      }),
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      rules: {
        systemNo: [
          { required: true, message: "请输入系统编码", trigger: "blur" },
        ],
        roleNo: [
          { required: true, message: "请输入角色代码", trigger: "blur" },
        ],
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          saveOrUpdateRole(this.editForm)
            .then(() => {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
              });
            });
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("udpaet:editForm", {});
      this.$refs.editForm.resetFields();
    },
  },
};
</script>

 
 

 


// WEBPACK FOOTER //
// src/views/system/role/add-edit/index.vue